import { getToken } from "@/services/api/auth.js";
import { sessaoFoiRevogada, voltarParaOAdmin } from "@/services/sso.js";

export async function apiRequest({ client = {}, orderBy= [], method = "", url, params = {}, body = {}, sendToken = true, headers = {}, responseType }){
    try {
        let orderByStr = '';
        if (orderBy.length) {
            orderByStr = 'orderBy=' + orderBy
                .map(s => `${s.key} ${s.desc ? 'desc' : 'asc'}`)
                .join('|')
        }
        if (sendToken) {
            const token = getToken();
            headers.Authorization = `Bearer ${token}`;
        }

        let finalUrl = url;
        if (orderByStr) {
            finalUrl += (url.includes('?') ? '&' : '?') + orderByStr;
        }

        const response = await client.request({
            method,
            url: finalUrl,
            params,
            data: body,
            headers,
            // So passado quando pedido (ex: 'blob', para baixar um arquivo
            // exportado) -- o default do axios ('json') continua valendo
            // para toda chamada que nao precisa disto.
            ...(responseType ? { responseType } : {}),
        });

        return response.data || response;
    } catch (error) {
        if (sessaoFoiRevogada(error)) {
            // Saiu da plataforma em outra aplicacao. Aqui nao ha tela de login
            // para onde cair: quem resolve sessao e o admin.
            localStorage.clear();
            voltarParaOAdmin({
                motivo: 'sessao-encerrada',
                retornarPara: window.location.pathname + window.location.search,
            });

            // A pagina esta indo embora: nao resolve nem rejeita, para a tela
            // nao piscar um erro no caminho.
            return new Promise(() => {});
        }

        return Promise.reject(error);
    }
}
